import { IPostMessage, OauthClient } from '../types';

export default class PostMessage {
    protected message: MessageEvent;
    readonly action: string;
    readonly payload: IPostMessage.Payload;

    constructor(message: MessageEvent) {
        this.message = message;

        if (typeof message.data.action == 'string') {
            this.action = message.data.action;
        }

        if (message.data.payload) {
            this.payload = message.data.payload;
        }
    }

    isFromAuthServer(oauthClient: OauthClient) {
        return (
            this.action &&
            typeof this.action == 'string' &&
            (this.message.origin != oauthClient.getCurrentHost() || this.message.origin != oauthClient.getServer())
        );
    }
}
